jQuery(function ($) {

  // js-slick
	$('.js-mv-slick').slick({
		autoplaySpeed: 4000,
		autoplay: true,
		arrows: false,
		dots: true,
		infinite: true,
		fade: false,
		speed: 1800,
		slidesToShow: 1,
		slidesToScroll: 1,
	});

});
